import React, { createContext, useContext, useEffect, useState } from "react";
import {
  nameMooda,
  publicRequest,
  slugMooda,
  urlSiteMooda,
} from "../../requestMethods";
import { resolveShowCashback } from "../../util/companyConfig";

const initialCompanyContext = {
  minProduct: 15,
  imgLogo: "defaultLogo.svg",
  companyName: nameMooda,
  companyId: 0,
  slug: slugMooda,
  showDashboard: true,
  showCashback: false,
  enabledPayment: false,
  cashback: false,
  isRetail: undefined,
  layout: "default",
  externalIntegration: false,
  urlExternalIntegration: undefined,
  accessControl: undefined,
  hootspy: undefined,
  midiaReport: undefined,
  unitProduct: { unit: "pc", unitLabel: "peças" },
};

export const CompanyContext = createContext();

export const CompanyContextProvider = (props) => {
  const [data, setData] = useState({
    configRules: {
      minProducts: 0,
      cashback: true,
    },
    configUI: {
      imgLogo: [],
    },
    name: nameMooda,
    companyId: 0,
    slug: slugMooda,
    planContract: {
      showPrice: false,
      showDashboard: true,
      showCashback: false,
    },
    enabledPayment: false,
    externalIntegration: false,
    accessControl: undefined,
  });
  const [contextData, setContextData] = useState(initialCompanyContext);

  useEffect(() => {
    // eslint-disable-next-line no-unused-vars
    const [_ignoreFirstSlash, rootParam] = window.location.pathname.split("/");

    getCompany(rootParam.toLowerCase());
  }, []);

  const [logo, setLogo] = useState();
  const [minProducts, setMinProducts] = useState();
  const [cashback, setCashback] = useState();
  const [name, setName] = useState();
  const [showDashboard, setShowDashboard] = useState();
  const [showCashback, setShowCashback] = useState();
  const [isRetail, setIsRetail] = useState();
  const [layout, setLayout] = useState();
  const {
    configRules,
    configUI,
    name: remoteName,
    slug,
    companyId,
    planContract,
    enabledPayment,
    externalIntegration,
    urlExternalIntegration,
    accessControl,
    hootspy,
    midiaReport,
  } = data;

  useEffect(() => {
    generateManifest(name ?? initialCompanyContext.companyName);
    setContextData({
      minProduct: minProducts ?? initialCompanyContext.minProduct,
      imgLogo: logo ?? initialCompanyContext.imgLogo,
      companyName: name ?? initialCompanyContext.companyName,
      companyId: companyId ?? initialCompanyContext.companyId,
      slug: slug ?? initialCompanyContext.slug,
      enabledPayment: enabledPayment ?? initialCompanyContext.enabledPayment,
      cashback: cashback ?? initialCompanyContext.cashback,
      showDashboard:
        planContract && planContract.showDashboard
          ? planContract.showDashboard
          : initialCompanyContext.showDashboard,
      // Precedência configRules.cashback -> planContract.showCashback: a flag
      // migrou do plano (painel interno) para as regras da empresa, e empresas
      // com cashback ligado em configRules ficavam sem o menu.
      showCashback: resolveShowCashback(
        configRules,
        planContract,
        initialCompanyContext.showCashback,
      ),
      isRetail: isRetail ?? initialCompanyContext.isRetail,
      layout: layout ?? initialCompanyContext.layout,
      externalIntegration:
        externalIntegration ?? initialCompanyContext.externalIntegration,
      urlExternalIntegration:
        urlExternalIntegration ?? initialCompanyContext.urlExternalIntegration,
      accessControl: accessControl ?? initialCompanyContext.accessControl,
      hootspy: hootspy ?? initialCompanyContext.hootspy,
      midiaReport: midiaReport ?? initialCompanyContext.midiaReport,
      unitProduct: planContract?.unitProduct ?? initialCompanyContext.unitProduct,
    });
  }, [
    logo,
    minProducts,
    name,
    companyId,
    slug,
    showDashboard,
    showCashback,
    configRules,
    planContract,
    enabledPayment,
    cashback,
    isRetail,
    layout,
    externalIntegration,
    urlExternalIntegration,
    accessControl,
    hootspy,
    midiaReport,
  ]);

  useEffect(() => {
    if (configUI && configUI.imgLogo) {
      configUI.imgLogo.map((item) =>
        setLogo(item.newName ? item.newName : item)
      );
    }
    if (configRules && configRules.minProducts) {
      setMinProducts(configRules.minProducts);
    }
    if (configRules) {
      setCashback(configRules.cashback);
    }
    if (planContract && planContract.showDashboard) {
      setShowDashboard(planContract.showDashboard);
    }
    if (planContract && planContract.showCashback) {
      setShowCashback(planContract.showCashback);
    }
    if (configUI && configUI.isRetail) {
      setIsRetail(configUI.isRetail);
    }
    if (configUI && configUI.layout) {
      setLayout(configUI.layout);
    }
    setName(remoteName);
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [data]);

  const getCompany = async (currentCompany) => {
    try {
      const res = await publicRequest.get(`/company/${currentCompany}`);

      if (Object.keys(res.data).length > 0) {
        //if (!res.data.planContract.moodapay) {
        setData(res.data);
        //}
      }
    } catch (error) {}
  };

  const generateManifest = (cp) => {
    var myDynamicManifest = {
      name: "Admin " + cp,
      short_name: "Admin " + cp,
      dir: "auto",
      display: "standalone",
      orientation: "Portrait",
      prefer_related_applications: false,
      related_applications: [],
      icons: [
        {
          src: "theme/icons/mooda_logo_icon.svg",
          sizes: "48x48 72x72 96x96 128x128 150x150 256x256 512x512",
          type: "image/svg+xml",
        },
      ],
      start_url: window.location.href,
      //background_color: "#000000",
      theme_color: "#EE8253",
    };

    if (cp !== "Mooda") {
      const stringManifest = JSON.stringify(myDynamicManifest);
      const blob = new Blob([stringManifest], { type: "application/json" });
      const manifestURL = URL.createObjectURL(blob);
      const manifest = document.getElementById("manisfestJson");
      if (manifest) {
        manifest.setAttribute("href", manifestURL);
      }
    }
  };
  return (
    <CompanyContext.Provider value={contextData}>
      {props.children}
    </CompanyContext.Provider>
  );
};

export const WithCompanyContext = (Component) => {
  const MixinComponent = (props) => {
    return (
      <CompanyContextProvider>
        <Component {...props} />
      </CompanyContextProvider>
    );
  };

  return MixinComponent;
};

export function useCompany() {
  const context = useContext(CompanyContext);
  return context;
}
